var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c("div", { staticClass: "panel panel-grey" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: {
                          model: _vm.$v.stateFirstName,
                          "field-name": "First name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: {
                          model: _vm.$v.stateLastName,
                          "field-name": "Last name",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12 col-lg-6" },
                    [
                      _c("field-input", {
                        attrs: {
                          model: _vm.$v.stateEmail,
                          "field-name": "Email",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$showDepartmentField
                    ? _c(
                        "div",
                        { staticClass: "col-md-12 col-lg-6" },
                        [
                          _c("department-selection", {
                            attrs: { model: _vm.$v.stateDepartment },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12 col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: _vm.$v.stateRole.$error
                          ? "has-error red-border"
                          : "",
                      },
                      [
                        _c("label", { staticClass: "control-label col-sm-4" }, [
                          _vm._v(
                            "\n                      * Role\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-8" },
                          [
                            _c("selectize", {
                              staticClass:
                                "form-control selectize selectize-single",
                              class: _vm.$v.stateRole.$error
                                ? "has-error red-border"
                                : "",
                              attrs: { name: "role", options: _vm.roleOptions },
                              model: {
                                value: _vm.$v.stateRole.$model,
                                callback: function ($$v) {
                                  _vm.$set(_vm.$v.stateRole, "$model", $$v)
                                },
                                expression: "$v.stateRole.$model",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.stateRole.$error
                              ? _c(
                                  "div",
                                  { staticClass: "help-block pull-right" },
                                  [_vm._v("Role is required")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleAddAdminCallback,
                    },
                  },
                  [_vm._v("\n              Add Admin\n            ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Add Admin")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }